import { FC } from 'react';
import { LiveAgent } from '@app/form_components/LiveAgent';

export const SettingsLiveAgentPage: FC = () => {
  return (
    <div className="row">
      <div className="col-md-12">
        <LiveAgent />
      </div>
    </div>
  );
};
